import { useCurrentUser } from '../../shared/store-user.hooks';
import { ConditionContext, validatesCondition } from '../../utils/conditionUtils';

type RegistrationConditionHolder = {
  registrationCondition?: ConditionContext;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ConditionUser = { _id: string; [x: string]: any };

/**
 * A workshop session may carry a `registrationCondition` (a user-condition set in the backoffice).
 * Users who don't validate it are not allowed to register to that session.
 *
 * KNOWN BEHAVIOUR CHANGE: on a session carrying a condition, an anonymous user has no fields to
 * evaluate, so the condition fails and the register button is hidden. Previously the button was
 * always shown and clicking it opened the "create your account" modal (UserRegistrationModal).
 * Left as-is for now: showing a button that may turn out to be unavailable right after signing up
 * is arguably worse. To restore the old flow, treat a missing user as "condition met" here and let
 * the check run again once the user is logged in.
 */
export function meetsRegistrationCondition(
  workshopOrSession: RegistrationConditionHolder | null | undefined,
  user: ConditionUser | null | undefined,
): boolean {
  const { registrationCondition } = workshopOrSession || {};
  if (!registrationCondition) return true;
  return validatesCondition(registrationCondition, user);
}

export function useMeetsRegistrationCondition(
  workshopOrSession: RegistrationConditionHolder | null | undefined,
): boolean {
  const user = useCurrentUser();
  return meetsRegistrationCondition(workshopOrSession, user);
}
